import { useQuery } from "@apollo/client";
import { Col, Row, Typography } from "antd";
import { CharacterCard } from "../components/Character";
import POLITICS from "../queries/politique.graphql";
import Markdown from "../components/Markdown";

const DRIVE_LINK = "https://drive.google.com/drive/folders/1R6FJIHtDW5_97Iz-U_eiMTci4tFkRyfV?usp=sharing";

function PolitiquePage() {
  const { data, loading, error } = useQuery(POLITICS);
  return (
    <div className="content">
      <Typography.Title level={2}>Triumvirat</Typography.Title>
      <Row gutter={[16, 16]} align="center" justify="middle">
        {data?.politique?.data.attributes.triumvirats.data.map(({ id, attributes }) => (
          <Col xs={24} sm={8} key={id}>
            <CharacterCard id={id} data={attributes} />
          </Col>
        ))}
      </Row>

      <Typography.Title level={2}>Conseiller</Typography.Title>
      <Row gutter={[16, 16]} align="center" justify="middle">
        {data?.politique?.data.attributes.conseillers.data.map(({ id, attributes }) => (
          <Col xs={24} sm={8} key={id}>
            <CharacterCard id={id} data={attributes} />
          </Col>
        ))}
      </Row>

      <Typography.Title level={2}>Roles</Typography.Title>
      <Row gutter={[16, 16]}>
        <Col>
          {data?.politique?.data.attributes.roles.map(({ id, key, value, description }) => (
            <div key={`${key}-${id}`}>
              <Typography.Title level={3}>{key} - {value}</Typography.Title>
              <Markdown>{description}</Markdown>
            </div>
          ))}
        </Col>
      </Row>

      <Typography.Title level={2}>Appuis</Typography.Title>
      <Row gutter={[16, 16]}>
        <Col>
          <Typography.Text>
            Limite d’appui (Nombre restreint de points : 15 points total)
            L’Appui de la Fondation envers Québec se limite à 15 points. En ce moment, il reste 3 points librent qui
            seront disponibles par objectifs communs à toutes branches de la Fondation.

            Une fois la limite atteinte, la disponibilité de l’Appui revient lorsqu’une branche en perd.
          </Typography.Text>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col justify="middle">
          {data?.politique?.data.attributes.appuis.map(({ id, groupe, points }) => (
            <div key={`${groupe.name}-${id}`} style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
              <Typography.Text style={{ fontSize: 18, fontWeight: 400, flex: 1, marginRight: 20 }}>
                {groupe.data.attributes.name} ({points})
              </Typography.Text>
              {Array.from({ length: points }, (_, i) => (
                <span key={i} className="point" />
              ))}
              {Array.from({ length: 15 - points }, (_, i) => (
                <span key={i} className="point-available" />
              ))}
            </div>
          ))}
        </Col>
      </Row>
    </div>
  );
}

export default PolitiquePage;
